// React & Core Hooks
import React, { createContext, useContext, useState } from "react";

// Internal Components
import Modal from "../components/Modal";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [modalData, setModalData] = useState({
        isOpen: false,
        type: "default", // default, confirmation, information, formInput
        title: "",
        content: null,
        inputValue: "",
        onConfirm: null,
        onCancel: null,
    });

    // Function to show a modal
    const showModal = (type, title, content, onConfirm = null, onCancel = null) => {
        setModalData({
            isOpen: true,
            type,
            title,
            content,
            onConfirm,
            onCancel,
        });
    };

    // Function to show a modal with input field
    const showInputModal = (title, placeholder, buttonText, onConfirm) => {
        setModalData({
            isOpen: true,
            type: "formInput",
            title,
            placeholder,
            inputValue: "",
            onConfirm,
            buttonText
        });
    };

    const hideModal = () => {
        setModalData({ isOpen: false, type: "default", title: "", content: null, onConfirm: null, onCancel: null });
    };

    const updateInputValue = (value) => {
        setModalData((prev) => ({ ...prev, inputValue: value }));
    };

    return (
        <ModalContext.Provider value={{ showModal, showInputModal, hideModal, updateInputValue, modalData }}>
            {children}
            <Modal {...modalData} onClose={hideModal} updateInputValue={updateInputValue} />
        </ModalContext.Provider>
    );
};

export const useModal = () => useContext(ModalContext);